import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import { confirm } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'
import notify from 'devextreme/ui/notify'

//copy paste this code to create new modal

class Notes extends Component {
  constructor(props) {
    super(props)

    this.type =
      this.props.action === 'suspend'
        ? 'Suspend'
        : this.props.action === 'deactive'
        ? 'Non Aktive'
        : this.props.action === 'active'
        ? 'Aktivasi'
        : 'Hapus'

    this.state = {
      popupVisible: false,
      dataNote: {
        username: '',
        notes: '',
      },
    }

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let confirms = await confirm(
              `Apakah Anda Yakin ${this.type} Data Ini ?`,
              'Konfirmasi'
            )
            if (confirms) {
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.formItems = [
      {
        dataField: 'notes',
        label: {
          visible: false,
          alignment: 'left',
          text: `${this.type} Notes`,
          location: 'left',
        },
        editorType: 'dxTextBox',
        editorOptions: {
          elementAttr: { class: 'bd-textarea-popup-dapen-default' },
        },
      },
    ]

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.onShown = this.onShown.bind(this)

    this.formRef = React.createRef()
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  onShown = (e) => {
    this.formRef.current.instance.getEditor('notes').focus()
  }

  hide() {
    this.setState({
      popupVisible: false,
      dataNote: {
        username: '',
        notes: '',
      },
    })
  }

  retrieveData = (data) => {
    if (data) {
      this.setState({
        dataNote: {
          username: data.username,
          notes: '',
        },
      })
    }
  }

  submitData = async () => {
    const { username, notes } = this.state.dataNote

    try {
      if (this.props.action === 'suspend') {
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          `wp/participant-users/suspend/${username}`,
          'POST',
          {
            values: {
              note: notes,
            },
          }
        )
      }
      if (this.props.action === 'deactive') {
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          `wp/participant-users/deactivate/${username}`,
          'POST',
          {
            values: {
              note: notes,
            },
          }
        )
      }
      if (this.props.action === 'active') {
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          `wp/participant-users/activate/${username}`,
          'POST',
          {
            values: {
              note: notes,
            },
          }
        )
      }
      if (this.props.action === 'delete') {
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          `wp/participant-users/${
            this.props.store.getState().sessionUser.participantId
          }`,
          'DELETE',
          username
        )
      }

      this.hide()
      notify(
        {
          message: `Berhasil ${this.type} Data!`,
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'success',
        1000
      )
      this.props.forceRefresh()
    } catch (e) {
      console.log(e)
      this.hide()
      notify(
        {
          message: `500 : Internal Server Error`,
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        1000
      )
    }
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={true}
        showTitle={true}
        title={`Catatan ${this.type} User`}
        width={500}
        height={200}
        onShown={this.onShown}
        ref={this.PopupRef}
        toolbarItems={this.PopupToolbarItem}
      >
        <Form
          colCount={1}
          id={'formMaster'}
          formData={this.state.dataNote}
          items={this.formItems}
          ref={this.formRef}
        />
      </Popup>
    )
  }
}

export default Notes
